var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6618 3.08642L10.9124 1.33759C10.8583 1.28331 10.7941 1.24027 10.7233 1.21094C10.6525 1.18161 10.5766 1.16656 10.5 1.16667H3.5C3.42338 1.16656 3.3475 1.18161 3.27672 1.21094C3.20594 1.24027 3.14166 1.28331 3.08758 1.33759L1.33817 3.08642C1.28367 3.14048 1.24044 3.20483 1.211 3.27572C1.18156 3.34662 1.16649 3.42266 1.16667 3.49942V11.0833C1.16667 11.7268 1.68992 12.25 2.33333 12.25H11.6667C12.3101 12.25 12.8333 11.7268 12.8333 11.0833V3.49942C12.8335 3.42266 12.8184 3.34662 12.789 3.27572C12.7596 3.20483 12.7163 3.14048 12.6618 3.08642ZM3.7415 2.33334H10.2585L10.8412 2.91609H3.15875L3.7415 2.33334ZM2.33333 11.0833V4.08276H11.6667L11.6678 11.0833H2.33333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.99999H5.25V5.83333H4.08333V8.16666H9.91666V5.83333H8.75V6.99999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.ca7c5d2d62c6b03ee87b8d7e06230138.svg";
export { ForwardRef as ReactComponent };